var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.onBoardingShow
    ? _c("div", { staticClass: "onboarding_wrap" }, [
        _c("div", { staticClass: "onboarding_con" }, [
          _c("h3", { domProps: { innerHTML: _vm._s(_vm.onBoardingTitle) } }),
          _vm._v(" "),
          _c(
            "ol",
            _vm._l(_vm.messageItemList, function(item, idx) {
              return _c("li", { key: idx }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("cop.onboarding.message.title." + item)))
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("cop.onboarding.message.content." + item)
                    )
                  }
                })
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "button" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-normal",
                attrs: { type: "button" },
                on: {
                  click: function() {
                    return (_vm.onBoardingShow = false)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("sdl.common.label.close")))]
            ),
            _vm._v(" "),
            !_vm.hideDontShowAgain
              ? _c("div", { staticClass: "fx_form" }, [
                  _c("label", [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      on: { change: _vm.dontShowAgain }
                    }),
                    _vm._v(_vm._s(_vm.$t("cop.onboarding.message.dontShow")))
                  ])
                ])
              : _vm._e()
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7209cc57", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7209cc57","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/OnBoarding.vue
// module id = null
// module chunks = 